<template>
  <div>
      <ul class="tree" style="display:block;" v-for="listTreeCategories in listCategories" v-bind:key="listTreeCategories.id">
        <li>
          <input type="checkbox" class="inputCheckTree" :id="'c' + listTreeCategories.id" v-if="listTreeCategories.categoriesList.length > 0"/>
          <label class="tree_label" :for="'c' + listTreeCategories.id">
          <input type="checkbox" class="inputCheck" :checked="listTreeCategories.checked" :id="'inputCheck' + listTreeCategories.id" :data-id-categories="listTreeCategories.id" @click="checkCategories(listTreeCategories.id)"/>
          {{ listTreeCategories.description }}</label>
          <treeCategories :listCategories="listTreeCategories.categoriesList" v-if="listTreeCategories.categoriesList.length > 0"></treeCategories>
        </li>
      </ul>
  </div>
</template>

<script>
import TreeCategories from "@/components/TreeCategories.vue";

export default {
  name: "TreeCategories",
  props: {
    listCategories: Array
  },
  data(){
    return{
    }
  },
  created: function(){
  },
  methods: {
    checkCategories(id){
      var listCategories = this;
      var checkedCategories = false;
      if($('#inputCheck' + id).is(':checked')){
        checkedCategories = true;
      }
      if(!functionHelpers.isValued(this.$parent.checkCategoriesClick)){
        if(!functionHelpers.isValued(this.$parent.$parent.checkCategoriesClick)){
          if(!functionHelpers.isValued(this.$parent.$parent.$parent.checkCategoriesClick)){
            this.$parent.$parent.$parent.$parent.checkCategoriesClick(id, checkedCategories);
          }else{
            this.$parent.$parent.$parent.checkCategoriesClick(id, checkedCategories);
          }
        }else{
          this.$parent.$parent.checkCategoriesClick(id, checkedCategories);
        }
      }else{
        this.$parent.checkCategoriesClick(id, checkedCategories);
      }
    },
  }
};
</script>
<style scoped>
/*
  Tree styles
*/
.tree { 
  margin: 5px;
  padding-left: 12px;
  transition:all ease-in-out 0.25;
}
.tree div{
  transition:all ease-in-out 0.25;
} 

.tree input.inputCheckTree {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  }

.tree input.inputCheckTree ~ div { display: block;
  transition:all ease-in-out 0.25; }

.tree input.inputCheckTree:checked ~ div { display: block;
  transition:all ease-in-out 0.25; }

/*
  Tree rows
*/
.tree li {
  line-height: 1.2;
  position: relative;
  padding: 0 0 5px 5px;
}

.tree ul li { padding:5px 0 0 5px; }

.tree > li:last-child { padding-bottom: 0; }

/*
  Tree labels
*/
.tree_label {
  white-space:nowrap;
  position: relative;
  display: inline-block;
  background: #fafafa;
  margin-bottom:5px;
  }

label.tree_label {
    color: #303c54;
    font-size: 13px;
    font-weight: lighter;
}

label.tree_label:hover { color: #666; }

/* 
  Tree icon
*/
label.tree_label:before {
  font-family: "FontAwesome";
  color: #20a8d8;
  position: relative;
  z-index: 0;
  float: left;
  font-size:15px;
  margin: 0 0.7em 0 -1em;
  border-radius: 1em;
  content: "\f07b";
  text-align: center;
  line-height: .9em;
  }

:checked ~ label.tree_label:before { 
  font-family: "FontAwesome";
  content: '\f07c';
}

/* 
  Tree branches
*/
.tree li:before {
  position: absolute;
  top: 0;
  bottom: 0;
  left: -.5em;
  display: block;
  width: 0;
  border-left: 1px solid #fff;
  content: "";
  }

.tree_label:after {
  position: absolute;
  top: 0;
  left: -1.5em;
  display: block;
  height: 0.5em;
  width: 1em;
  border-bottom: 1px solid #fff;
  border-left: 1px solid #fff;
  border-radius: 0 0 0 .3em;
  content: '';
  }

label.tree_label:after { border-bottom: 0; }

:checked ~ label.tree_label:after {
  bottom: 0;
  top: 0.5em;
  height: auto;
  }

.tree li:last-child:before {
  height: 1em;
  bottom: auto;
  }

.tree > li:last-child:before { display: none; }

.tree_custom {
  display: block;
  background: #eee;
  padding: 1em;
  border-radius: 0.3em;
}
li {
  list-style: none;
}
.inputCheck {
  margin-right:5px;
}
</style>
